import BasicCardContainer from "../../components/bonusUi/basicCard";

const BasicCard = () => {
  return <BasicCardContainer />;
};

export default BasicCard;
